import { Layout, Dropdown, Space } from "antd";
import { LogoutOutlined, QuestionOutlined, InfoCircleOutlined } from "@ant-design/icons"
import i18n from "../../assets/images/icon_i18n.svg"
import avator from "../../assets/images/icon_avatar.svg"
import logoMax from "../../assets/images/logo_UMC_maxi.svg"
import { DEFAULT_HEADER_STYLE, UNAUTH_HEADER_STYLE } from "../../styles/styleUtils";
import { useDispatch, useSelector } from "react-redux";
import { setContentLoading, setLanguage, setLoader, setSelectedApplication } from "../../store/reducers/CommonReducer";
import { GIVENNAME, LANG_LIST, SURNAME } from "../../utils/Constants";
import SearchBot from "../bot/SearchBot";
import { capitalizeFirstLetter, getTranslated } from "../../utils/CommonUtils";
import { getLocalItem } from "../../utils/storageUtils";
import { useNavigate } from "react-router-dom";
import { IAM_URL } from '../../utils/Config'
import { getRelaseNotes } from "../../store/actions/CommonActions"
import confirmModal from "../common/confirmModal"
import { removeGTM, sendGTMEvent } from "../../utils/GTMUtils";

const UMCHeader = (props) => {

    const language = useSelector((state) => state.common.language)
    const dict = useSelector((state) => state.common.dict)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const menuItems = [
        {
            key: "faq",
            label: getTranslated(dict, "LABEL_FAQ"),
            icon: <QuestionOutlined />,
            onClick: () => {
                sendGTMEventOnClick("FAQ")
                window.open(`/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_faq.html`, "_blank")
            }
        },
        {
            key: "help_online",
            label: getTranslated(dict, "LABEL_HELP"),
            icon: <InfoCircleOutlined />,
            onClick: () => {
                sendGTMEventOnClick("HOL")
                window.open(`/hol/index-${language}.html`, "_blank")
            }
        },
        {
            key: "release_notes",
            label: getTranslated(dict, "LABEL_RELEASE_NOTES"),
            icon: <InfoCircleOutlined />,
            onClick: () => {
                handleReleaseNote()
                sendGTMEventOnClick("Release_note")
            }
        },
        {
            key: "logout",
            label: getTranslated(dict, "LABEL_LOGOUT"),
            danger: true,
            icon: <LogoutOutlined />,
            onClick: () => handleLogout()
        },
    ]

    const sendGTMEventOnClick = (item) => {
        sendGTMEvent({
            event: "umc_user_menu_selection",
            selected_item: item
        })
    }

    const handleLogout = () => {
        dispatch(setLoader(true))
        dispatch(setSelectedApplication(""))
        console.log("UMCHeader: Logout")
        navigate("/logout")
    }

    const handleReleaseNote = () => {
        const apiUrl = `${IAM_URL}/appinfo/releasenotes`
        dispatch(setContentLoading(true))
        dispatch(getRelaseNotes(apiUrl, 
            (status, data) => {
            if (status) {
                dispatch(setContentLoading(false))
            } else {
                dispatch(setContentLoading(false))
                confirmModal({
                    title: getTranslated(dict, "LABEL_FAILED"),
                    okText: getTranslated(dict, "LABEL_CLOSE"),
                    content: Object.values(data || {}).join(", ")
                })
            }
        }, "ReleaseNote.pdf"))
    }

    return <>
        {props.status === 200 ?
            <Layout.Header style={DEFAULT_HEADER_STYLE}>
                <div className="header-div" style={{ display: "flex", alignItems: "center", justifyContent: "right", height: "inherit" }}>

                    {/* {!props.unAuth && <SearchBot />} */}

                    <Dropdown
                        className="header-item lang-dd"
                        menu={{
                            items: LANG_LIST,
                            selectable: true,
                            selectedKeys: [language],
                            onSelect: ({ item, key, keyPath, selectedKeys, domEvent }) => {
                                dispatch(setLanguage(key))
                            }
                        }}
                    >
                        <Space>
                            <><img src={i18n} alt="Internationalization icon" className="header-icon" />{capitalizeFirstLetter(language)}</>
                        </Space>
                    </Dropdown>


                    <div className="header-item">
                        <Dropdown
                            menu={{ items: props.unAuth ? [] : menuItems }}
                            placement="bottomRight"
                        >
                            <div className="profile-section" >
                                <span className="profile-username">{props.unAuth ? getTranslated(dict, "LABEL_DISCONNECTED") : `${getLocalItem(GIVENNAME)} ${getLocalItem(SURNAME)}`}</span>
                                <img src={avator} alt="User profile" className="header-icon" />
                            </div>
                        </Dropdown>
                    </div>
                </div>
            </Layout.Header>
            :
            <Layout.Header style={{ ...DEFAULT_HEADER_STYLE, ...UNAUTH_HEADER_STYLE }} className="unauth-hd">
                <img src={logoMax} alt="LogoUMC" className={"logo-umc-unauth-hd"} />
            </Layout.Header>
        }
    </>

}

export default UMCHeader